import { useTranslate } from "@tolgee/react";
import { Button } from "#/components/ui/button.tsx";
import { cn } from "#/lib/utils";
import {
	type OrderSide,
	orderSideOptions,
} from "./constants/order-form.constants.ts";

type OrderSideToggleProps = {
	side: OrderSide;
	onChange: (nextSide: OrderSide) => void;
};

export function OrderSideToggle({ side, onChange }: OrderSideToggleProps) {
	const { t } = useTranslate();

	return (
		<div className="grid grid-cols-2 gap-1.5 sm:gap-2">
			{orderSideOptions.map((item) => {
				const isActive = side === item.key;

				return (
					<Button
						key={item.key}
						onClick={() => onChange(item.key)}
						className={cn(
							"min-h-8 rounded-[7px] border border-trade-border-subtle bg-trade-interactive px-2 text-label2-bold text-trade-text transition-[transform,background-color,color] hover:bg-trade-interactive-hover sm:min-h-10 sm:rounded-[10px] sm:text-body2-bold",
							isActive &&
								item.key === "buy" &&
								"border-transparent bg-primary shadow-[inset_0_1px_0_rgba(255,255,255,0.12)] hover:bg-primary text-primary-foreground",
							isActive &&
								item.key === "sell" &&
								"border-transparent bg-trade-red text-trade-accent-text shadow-[inset_0_1px_0_rgba(255,255,255,0.12)] hover:bg-trade-red text-[var(--color-theme-static-white)]",
						)}
					>
						{t(item.labelKey)}
					</Button>
				);
			})}
		</div>
	);
}
